import { Pipe, PipeTransform } from '@angular/core';
import { LocaleDto } from '../../../../../api/src/creative-unit-package/models/locale.dto';
import { ObjectUtils } from '../../../../../api/src/_core/utils';

@Pipe({
	name: 'getLocale'
})
export class GetLocalePipe implements PipeTransform {
	transform(value: string, localeData: LocaleDto): string {
		return ObjectUtils.getLocale(value, localeData);
	}
}
